<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>彙整報表</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>核銷管理</span></li>
          <li><span>彙整報表</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body" align="left">
              <div align="left">
                請選擇匯出表格:
                <select v-model="exportType">
                  <option :value="null">請選擇</option>
                  <option value="總金額表">總金額表</option>
                  <option value="保費計算表">勞雇工讀生加保保費計算列表</option>
                  <option value="經費統計表">大專校院學生兼任助理分流及經費統計表</option>
                </select>
              </div><br>
              <div align="left" v-if="exportType=='總金額表' || exportType=='經費統計表'">
                請選擇學年度:
                <select v-model="type1.schYear">
                  <option v-for="item in getNumbersDesc(nowSchYear, 108)" :key="item" :value="item">{{item}}</option>
                </select><br><br>
              </div>
              <div align="left" v-if="exportType=='保費計算表'">
                請選擇年度/月份:
                <select v-model="type2.year">
                  <option v-for="item in getNumbersDesc(nowYear, 108)" :key="item" :value="item">{{item}}</option>
                </select>
                <select v-model="type2.month">
                  <option v-for="item in 12" :key="item" :value="item">{{item}}</option>
                </select><br><br>
              </div>
              <div align="center" v-if="exportType">
                <br>
                <a href="#" @click.prevent="download" class="btn-upload btn btn-primary" style="background-color:#0044BB; border-color:#0044BB;">確認匯出</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      nowSchYear: 108,
      nowYear: 108,
      exportType: null,
      type1: {
        schYear: null
      },
      type2: {
        year: null,
        month: null
      }
    };
  },
  mounted() {
    let d = this.nowDate();
    let nowYear = d.getFullYear() - 1911;
    let nowMonth = d.getMonth() + 1;
    //提前一個月
    if(nowMonth == 12){
      nowYear++;
      nowMonth = 1;
    }
    this.nowSchYear = nowYear;
    this.type1.schYear = nowYear;
    // 8月後為本年學年度上學期開始
    if (nowMonth < 8) {
      this.nowSchYear -= 1;
      this.type1.schYear -= 1;
    }
    this.nowYear = nowYear;
    this.type2.year = nowYear;
    this.type2.month = nowMonth;
  },
  methods: {
    download() {
      let url = "";
      if (this.exportType == "總金額表")
        url = "/api/verification/export-total-money?schYear=" + this.type1.schYear;
      else if (this.exportType == "保費計算表")
        url = "/api/verification/export-labor-calc?year=" + this.type2.year + "&month=" + this.type2.month;
      else if (this.exportType == "經費統計表")
        url = "/api/verification/export-total-fund?schYear=" + this.type1.schYear;
      this.$http
        .post(url, {}, { responseType: "arraybuffer" })
        .then(res => {
          this.download2File(res);
        });
    }
  }
};
</script>

<style>
</style>